export default __webpack_public_path__ + "123c938f70ac6102d5d38b24d9e82d11.svg";